// T271(3) — one reading, and one writing, of the operator's preferences.
//
// The same normalisation was written out five times across ProfilePage and
// OnboardingPage: the T096 "seniority may be a legacy string or an array"
// branch three times, the empty-string-for-a-missing-salary convention twice,
// the digestHour default twice. Every one of those is a place where a form
// hydrates differently from the fingerprint it is compared against, which is
// exactly the class of bug T267(1) turned out to be.
//
// The wire and the form disagree on purpose: a form field holds '' for "not
// set" because that is what an <input> gives you, and the API wants null. That
// translation is the whole reason these two functions exist as a pair.

const DEFAULT_DIGEST_HOUR = 8;

/** API shape → form shape. Always returns every field. */
export function normalizePrefs(p = {}) {
  return {
    targetRoles: p.targetRoles ?? [],
    targetLocations: p.targetLocations ?? [],
    // T096 — accepts the legacy single string and the current array.
    seniority: Array.isArray(p.seniority) ? p.seniority : p.seniority ? [p.seniority] : [],
    remotePreference: p.remotePreference ?? 'any',
    salaryMinimum: p.salaryMinimum ?? '',
    // T314 — '' is "not stated", and that is a real answer: scoreSalary will
    // not compare a floor against a differently-denominated salary, so an
    // unset currency disables the salary dimension rather than guessing.
    salaryCurrency: p.salaryCurrency ?? '',
    excludedCompanies: p.excludedCompanies ?? [],
    digestHour: p.digestHour ?? DEFAULT_DIGEST_HOUR,
  };
}

/** Form shape → PATCH /preferences body. */
export function prefsPayload(f = {}) {
  return {
    targetRoles: f.targetRoles ?? [],
    targetLocations: f.targetLocations ?? [],
    seniority: Array.isArray(f.seniority) ? f.seniority : [],
    remotePreference: f.remotePreference ?? 'any',
    // '' means "cleared", which is null on the wire — NOT 0, which is a real
    // and very different answer to "what is your salary floor".
    salaryMinimum: f.salaryMinimum === '' || f.salaryMinimum == null ? null : Number(f.salaryMinimum),
    salaryCurrency: f.salaryCurrency === '' || f.salaryCurrency == null ? null : f.salaryCurrency,
    excludedCompanies: f.excludedCompanies ?? [],
    // Number(undefined) is NaN, which JSON turns into null, which the backend's
    // z.coerce turns into 0 — a cleared field silently asking for midnight, the
    // same trap T267(3) found in the form. Fall back to the same default the
    // form hydrates with.
    digestHour: Number.isFinite(Number(f.digestHour)) && f.digestHour !== '' ? Number(f.digestHour) : DEFAULT_DIGEST_HOUR,
  };
}
